export default {
  routerObj: {
    path: '/home',
    component: () => import('@/views/home/index.vue'),
    name: '首页',
    children: []
  }
}
